import {
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Tooltip,
} from '@chakra-ui/react'
import type { FieldProps } from 'formik'
import { Field } from 'formik'
import { isNull, isUndefined } from 'lodash'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import type { CMFieldProps } from '.'
import { IKReactSelect } from '../../../../../ui-kit'
import type { CmFormValues } from '../../../../interfaces/FileDetailsResponse'
import EllipsisMiddle from '../../../EllipsisMiddle'

const labelString = (value: boolean | undefined): string | undefined =>
  isUndefined(value) || isNull(value) ? undefined : String(value)

const CMBooleanField = ({
  cmField,
  disabled,
  isUpload,
}: CMFieldProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Field name={`['${cmField.name}']`} key={`['${cmField.name}']`}>
      {({ field, form }: FieldProps<boolean | undefined, CmFormValues>) => (
        <FormControl
          marginBottom={isUpload ? 0 : '30px'}
          isInvalid={Boolean(form.errors[cmField.name])}
          isRequired={cmField.schema.isValueRequired}
          isDisabled={disabled || cmField.schema.readOnly}
        >
          <Tooltip label={cmField.label} placement="top-start">
            <FormLabel requiredIndicator={<></>}>
              <Flex maxWidth="20vw">
                <EllipsisMiddle
                  text={cmField.label}
                  required={cmField.schema.isValueRequired}
                  className="centerText"
                />
              </Flex>
            </FormLabel>
          </Tooltip>
          <Tooltip
            isDisabled={!cmField.schema.readOnly}
            label={t('read_only', 'Read only')}
            shouldWrapChildren
          >
            <IKReactSelect
              variant="compact"
              captureMenuScroll={false}
              menuPlacement="auto"
              placeholder={
                !(
                  isUndefined(cmField.schema.defaultValue) ||
                  isNull(cmField.schema.defaultValue)
                ) && isUpload
                  ? `${cmField.schema.defaultValue} (Default value)`
                  : ''
              }
              isDisabled={disabled || cmField.schema.readOnly}
              isClearable={true}
              value={
                !(isUndefined(field.value) || isNull(field.value)) && {
                  label: field.value.toString(),
                  value: field.value,
                }
              }
              options={[true, false].map(val => ({
                label: String(val),
                value: val,
              }))}
              onChange={newVal => {
                form.setTouched({ ...form.touched, [field.name]: true })
                if (isNull(newVal)) {
                  form.setFieldValue(field.name, null)
                } else {
                  form.setFieldValue(field.name, Boolean(newVal.value))
                }
              }}
            />
          </Tooltip>
          <FormErrorMessage>{form.errors[cmField.name]}</FormErrorMessage>
        </FormControl>
      )}
    </Field>
  )
}

export default CMBooleanField
